<div style="display: flex; overflow: hidden" class="w-100 h-100 flex-column">
  <section class="modal-header">
    <div class="header-action w-50">
      <button
        mat-stroked-button
        class="pri-button"
        type="button"
        (click)="clearAllSelected()"
      >
        Clear all <img src="assets/images/chat/popup-images/clear-all.png" />
      </button>
      <div class="call-btn d-flex justify-content-evenly">
        <!-- <button
          mat-mini-fab
          color="warn"
          class="mr-3"
          (click)="startCall(false)"
        >
          <mat-icon>call</mat-icon>
        </button> -->
        <button mat-mini-fab color="warn" (click)="startCall(true)">
          <mat-icon>videocam</mat-icon>
        </button>
      </div>
      <button
        class="close m-0"
        type="button"
        aria-label="Close modal popup"
        (click)="close()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <h3>Active Users</h3>
  </section>
  <section class="modal-body user-pop-up" style="flex: 1; overflow: hidden">
    <div class="modal-body-inner d-flex w-100 h-100 flex-column">
      <div>
        <section class="search-wrapper">
          <div class="search-cntr">
            <button type="button" aria-label="Search">
              <img src="assets/images/chat/popup-images/search.png" />
            </button>
            <input
              type="text"
              #searchInputText
              name="search"
              placeholder="Search"
            />
          </div>
        </section>
        <section>
          <div class="d-flex justify-content-center" *ngIf="isLoadingOnScroll">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </section>
        <section
          class="presenting-users"
          *ngIf="memberSelectedList && memberSelectedList.length > 0"
        >
          <ul>
            <li *ngFor="let item of memberSelectedList">
              <div class="img-cntr">
                <a
                  ><span (click)="removeemberSelected(item)" class="icon-cntr"
                    >&ndash;</span
                  ></a
                >
                <div class="img-cntr-inner">
                  <img src="{{ item.profileImg }}" onerror="this.src='assets/images/thumb_profile_image.png'"/>
                </div>
              </div>
              <p>{{ item.userName }}</p>
            </li>
          </ul>
        </section>
      </div>
      <section
        class="active-users"
        #usersScroll
        style="flex: 1; overflow-y: auto"
      >
        <ul class="list-group-flush">
          <ng-container *ngFor="let user of userlist; let i = index">
            <li
              *ngIf="user.isMemberSelected != true"
              (click)="SelectMember(user)"
            >
              <div>
                <div class="input-cntr">
                  <input
                    type="checkbox"
                    [disabled]="
                      memberSelectedList.length >= 6 ||
                      callService.streams.length >= 6
                    "
                    [ngModel]="user.isMemberSelected"
                    (click)="SelectMember(user)"
                    id="input-cntr-01{{ i }}"
                  />
                  <label for="input-cntr-01{{ i }}"></label>
                </div>
                <div class="img-cntr">
                  <span
                    *ngIf="user.availability == 1"
                    class="icon-cntr activeuser"
                  ></span>
                  <span
                    *ngIf="user.availability == 0"
                    class="icon-cntr logout"
                  ></span>
                  <span *ngIf="user.availability == 2" class="icon-cntr"></span>
                  <div class="lt-wsimg.image-cntr">
                    <img src="{{ user.profileImg }}" />
                  </div>
                </div>
                <h4>
                  {{ user.userName }}<span>{{ user.title }}</span>
                </h4>
              </div>
            </li>
          </ng-container>
        </ul>
      </section>
    </div>
  </section>
</div>
